module.exports = __webpack_public_path__ + "static/media/new-logo.927a1b02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/import-modules/zotero/ZoteroImportModal/new-logo.svg
// module id = 1101
// module chunks = 0